import { binds } from "../content/tuning";

export interface InputState {
  keys: Set<string>;
  down: Set<string>;
  pressed: Set<string>;
  mouseX: number;
  mouseY: number;
  mouseDown: boolean;
  mouseClicked: boolean;
}

export function normalizeKey(e: KeyboardEvent): string {
  const k = e.key.length === 1 ? e.key.toLowerCase() : e.key.toLowerCase();
  if (k === "spacebar") return " ";
  return k;
}

export function attachInput(canvas: HTMLCanvasElement): InputState {
  const state: InputState = {
    keys: new Set(),
    down: new Set(),
    pressed: new Set(),
    mouseX: canvas.clientWidth / 2,
    mouseY: canvas.clientHeight / 2,
    mouseDown: false,
    mouseClicked: false,
  };

  window.addEventListener("keydown", (e) => {
    const k = normalizeKey(e);
    const bound = Object.values(binds);
    if ([" ", "arrowup", "arrowdown", "arrowleft", "arrowright", "tab"].includes(k) || bound.includes(k)) {
      if (!(e.target instanceof HTMLInputElement) && !(e.target instanceof HTMLTextAreaElement) && !(e.target instanceof HTMLSelectElement)) {
        e.preventDefault();
      }
    }
    if (!state.down.has(k)) state.pressed.add(k);
    state.down.add(k);
    state.keys.add(k);
  });
  window.addEventListener("keyup", (e) => {
    const k = normalizeKey(e);
    state.down.delete(k);
    state.keys.delete(k);
  });
  canvas.addEventListener("mousemove", (e) => {
    const rect = canvas.getBoundingClientRect();
    state.mouseX = e.clientX - rect.left;
    state.mouseY = e.clientY - rect.top;
  });
  canvas.addEventListener("mousedown", (e) => {
    if (e.button === 0) {
      state.mouseDown = true;
      state.mouseClicked = true;
    }
  });
  window.addEventListener("mouseup", (e) => {
    if (e.button === 0) state.mouseDown = false;
  });
  window.addEventListener("blur", () => {
    state.down.clear();
    state.keys.clear();
    state.mouseDown = false;
  });

  return state;
}

export function endInputFrame(state: InputState): void {
  state.pressed.clear();
  state.mouseClicked = false;
}

export function skillPressed(state: InputState): boolean {
  return state.pressed.has(binds.skill);
}

export function ultPressed(state: InputState): boolean {
  return state.pressed.has(binds.ult);
}

export function moving(state: InputState): { x: number; y: number } {
  let x = 0;
  let y = 0;
  if (state.down.has("a") || state.down.has("arrowleft")) x -= 1;
  if (state.down.has("d") || state.down.has("arrowright")) x += 1;
  if (state.down.has("w") || state.down.has("arrowup")) y -= 1;
  if (state.down.has("s") || state.down.has("arrowdown")) y += 1;
  return { x, y };
}
